'use client';

import { useState, useCallback } from 'react';
import { SendOTPForm } from '@/components/auth/SendOTPForm';
import { VerifyOTPForm } from '@/components/auth/VerifyOTPForm';

interface LoginFormState {
  step: 'SEND_OTP' | 'VERIFY_OTP';
  email: string;
}

interface LoginFormProps {
  redirectTo?: string;
}

export function LoginForm({ redirectTo }: LoginFormProps) {
  const [formState, setFormState] = useState<LoginFormState>({ 
    step: 'SEND_OTP', 
    email: '' 
  });

  const handleOtpSent = useCallback((email: string) => {
    setFormState({ step: 'VERIFY_OTP', email });
  }, []);

  const handleBack = useCallback(() => {
    setFormState({ step: 'SEND_OTP', email: '' });
  }, []);

  return (
    <div className="w-full">
      {formState.step === 'VERIFY_OTP' ? (
        <VerifyOTPForm 
          email={formState.email} 
          onBack={handleBack}
          redirectTo={redirectTo}
        />
      ) : (
        <SendOTPForm onOtpSent={handleOtpSent} />
      )}
    </div>
  );
}
